import React, {useState, useEffect} from 'react';
import newId from '../../utils/newid';
import {optionsDefault, actionIcons} from "../../schema"
import style from './style.scss'
import Label from './Label'
import {Draggable, Droppable, DragDropContext} from "react-beautiful-dnd";
import {SketchPicker} from 'react-color';

const style2 = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
}

const Li = ({index, moveCard, children}) => {

    return (
        <li>
            {children}
        </li>
    )
}

const ColorField = React.memo((props) => {
    const {option, handleChange,isReadOnly} = props
    const [showPicker, setShowPicker] = useState(false);
    const [optionState, setOptionState] = useState(option);

    return (
        <div
            className={style.colorWrap}>
            <div onClick={() => {
                setShowPicker(!showPicker);
            }} >
              <span
                className={style.colorPikPrev}

                style={{background: optionState.color}}>&nbsp;</span>
                <span className={style.imageChange} >{optionState.color}</span>
            </div>
            {showPicker ?
                <div className={style.popover}>
                    <div
                        className={style.cover}
                        onClick={() => {
                            setShowPicker(false);
                        }}
                    />
                    <SketchPicker
                        color={optionState.color}
                        className={style.colorPicker}
                        disableAlpha={true}
                        readOnly={isReadOnly}
                        onChange={(color) => {
                            setOptionState({...option, color: color.hex})
                            handleChange(color.hex)
                        }}
                    />
                </div> : null}


        </div>
    );
})

const getListStyle = (isDraggingOver) => ({
    border: isDraggingOver
    ? 'solid 1px #a2a8a4'
    : 'solid 1px rgba(12, 14, 51, 0.15)',
    padding: 8
});
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: 8 * 2,
    margin: `0 0 ${8}px 0`,
    border :'solid 1px rgba(12, 14, 51, 0.15)',

    // change background colour if dragging
    background: isDragging ? 'white' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle
});


const ImageField = (props) => {
    const {option, handleChange} = props

    return (
        <div className={style.imageOption} onClick={() => {
            const frame = wp.media({
                title: 'Select or Upload Media Of Your Chosen Field',
                button: {
                    text: 'Use this media'
                },
                multiple: false  // Set to true to allow multiple files to be selected
            });
            frame.open();
            frame.on('select', function () {
                // Get media attachment details from the frame state
                var attachment = frame.state().get('selection').first().toJSON();

                handleChange(attachment);
            });
        }}>

            <img
                src={(typeof option.thumb !== 'undefined' && option.thumb !== '' && option.thumb !== 'null') ? option.thumb : option.image}/>
                <span className={style.imageChange} >{wp.i18n.__('Change')}</span>
        </div>
    );
}


const RenderOptions = (props) => {
    const {item, field, isReadOnly} = props;
    const { options, enablePrice, priceOptions} = field;
    const id = newId();

    let flg = false;
    let isMulti = false;
    if (typeof field.multiple !== "undefined" && field.multiple) {
        isMulti = true;
    } else if (field.type === 'checkboxGroup') {
        isMulti = true;
    }

          if( Array.isArray(options) ) {
            var _values = options.map(e => {
                if (e.tempId) return e;
                return {...e, tempId: newId()}
            });
          } else {
            var _values = Object.keys(options).map(e => {
                if (e.tempId) return e;
                // return {...e, tempId: newId() }
                return {...e, tempId: newId(), label:options[e], value: e  }
            });
         }

   const handleColorChange = (color, index) => {
       _values[index].color = color;
       return props.handleChange(_values);
   }

   const handleImgChange = (media, index) => {

       let thumb = typeof media.sizes.thumbnail !== 'undefined' ? media.sizes.thumbnail.url : media.url;
       _values[index].image = media.url;
       _values[index].thumb = thumb;
       _values[index].image_id = media.id;
       return props.handleChange(_values);
   }

    const handleChange = (event, index) => {

        if (event.target.name === 'selected') {
            if (event.target.type === 'radio') {
                _values = _values.map(e => {
                    return {...e, selected: false}
                });
                _values[index][event.target.name] = event.target.checked;
            } 
            else {
                _values[index][event.target.name] = event.target.checked;
            }

        } 
        else {
            _values[index][event.target.name] = event.target.value;
        }

        return props.handleChange(_values);
    }

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const [removed] = _values.splice(result.source.index, 1);
        _values.splice(result.destination.index, 0, removed);
        return props.handleChange(_values);
    };
    

    const removeOption = (i) => {
        _values.splice(i, 1);
        return props.handleChange(_values);
    }
    const addNew = () => {
        _values.push(optionsDefault(field.type));
        return props.handleChange(_values);
    }
    const clearSelection = ()=>{
        _values = _values.map(e => {
            return {...e, selected: false,tempId: newId()}
        });
        return props.handleChange(_values);
    }



    return (

        <div className={`${ ( field.type === 'imageGroup' || field.type === 'colorGroup' ) ? style.imageGroup : ''}`}>
            {
                (typeof item.label !== 'undefined') &&
                <Label
                    id={id}
                    label={item.label}
                />
            }
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                     <>
                            <ul {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}>

                {

                    _values.map((e, i) => {
                                        
                        return (
                                            

                                            <Draggable
                                            key={`ac_${e.tempId}`}
                                            draggableId={`id_${e.tempId}`}
                                            index={i}
                                            >
                                                {(provided, snapshot) => (
                                                    <li ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}

                                                        key={e.tempId}
                                                        index={i} 
                                                        className={style.repeater}

                                                        
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps
                                                            .style
                                                    )}
                                                    >
                                                        <span {...provided.dragHandleProps}
                                                          className={style.dragIcon}></span>
                                                    <div className={
                                                        style.checkField
                                                    }
                                                    >
                                                        
                                <input
                                    //type="radio"
                                    type={isMulti ? "checkbox" : "radio"}
                                    name='selected'
                                    defaultChecked={e.selected}
                                    onChange={(event) => {
                                        handleChange(event, i);
                                                          
                                    }}
                                                        
                                />
                                                        
                                                    
                                                        { e.selected ? flg = true  : '' }
                                                        {field.type === 'imageGroup' && 
                                                        <ImageField 
                                                        isReadOnly={isReadOnly}
                                                        handleChange={(media) => {
                                    handleImgChange(media, i);
                                }} option={e}/>}
                                                        
                                {field.type === 'colorGroup' &&
                                <ColorField
                                    isReadOnly={isReadOnly}
                                    handleChange={(color) => {
                                    handleColorChange(color, i);
                                }} option={e} />}
                                                       
                                                    
  
                                                        
                                <label> <span>Label</span>
                                    <input
                                        type="text"
                                        name="label"
                                        value={e.label}
                                        readOnly={isReadOnly}
                                        onChange={(event) => {
                                            handleChange(event, i);
                                        }}
                                    />
                                </label>
                                                    
                                <label> <span>Value <span className={style.req}> (<i>required</i>) </span></span>
                                    <input
                                        type="text"
                                        name="value"
                                        value={e.value}
                                        readOnly={isReadOnly}
                                        onChange={(event) => {
                                            handleChange(event, i);
                                        }}
                                    />
                                </label>
                                                       
                                    
                                    
                                {
                                    (enablePrice && priceOptions && enablePrice === 'diffrent_for_all') ?
                                        <input
                                            type="text"
                                            value={e.price}
                                            onChange={(event) => {
                                                handleChange(event, i);
                                            }}
                                        />
                                        : null
                                }
                                {i > 0 && <span className={style.removeOption} onClick={() => {
                                    removeOption(i)
                                }}><img src={actionIcons['trash'].icon} title={actionIcons['trash'].label}/></span>}
                                                    </div>
                            </li>
                                                )}   
                                            </Draggable>           
                                                        
                                    )}
                                                    
                                                    
                        )
                    //})
                }

                              

                                </ul> 
                                <div>
                    <span onClick={addNew} className={style.addOption}> {wp.i18n.__('Add new')} </span>
                
                                    { flg == false ? 
                    <span onClick={clearSelection} className={style.clearSel}>{wp.i18n.__('Clear Selection')}</span>
                    : '' }
                                    
                                </div>
                        </>
                        )}
                </Droppable>
            </DragDropContext>

        </div>


    )
}

export default RenderOptions;
